import React, { useState } from "react";
import { Box, Divider, IconButton, Badge } from "@mui/material";
import { ReplyAllOutlined } from "@mui/icons-material";
import NoteListItem from "./NoteListItem";
import EmptyResult from "components/Shared/Lottie/EmptyResult";
import { useAuth } from "hooks";
import { NoteReplies } from "./NoteReplyList";
import HoverablePaper from "components/Shared/HoverablePaper";

const NoteList = ({
  notes = [],
  onCommentEdit = () => { },
  onDisableNote = () => false,
  onNoteReplyClick = () => { },
  noteComponent: NoteComponent,
  isActive,
  showReplies = true,
}) => {
  const { loggedInUser, isCustomer, isVendor } = useAuth();
  const [openReplyBoxById, setOpenReplyBoxById] = useState(null);

  // Ensure notes is an array and filter based on user role
  const _sortedNoteList = Array.isArray(notes)
    ? [...notes]
      .filter((note) => (isCustomer || isVendor ? note.showClient : true))
      .sort((a, b) => (a?.createdAt > b?.createdAt ? -1 : 1))
    : [];

  return _sortedNoteList.length ? (
    _sortedNoteList.map((note, index) => {
      const replyCount = note?.replies?.length || 0;
      const hasReplies = replyCount > 0;

      return (
        <React.Fragment key={note._id}>
          <HoverablePaper>
            {!!NoteComponent ? (
              <NoteComponent note={note} hasReplies={hasReplies} />
            ) : (
              <NoteListItem note={note} hasReplies={hasReplies} />
            )}

            <HoverablePaper.Actions disableAnimation>
              <IconButton
                onClick={() => onCommentEdit(note)}
                disabled={
                  (note?.createdBy?._id !== loggedInUser?._id)
                }
              >
                {/* <EditOutlined /> */}
              </IconButton>
              <IconButton>
                <Badge
                  badgeContent={!showReplies ? replyCount : null}
                  color="primary"
                >
                  <ReplyAllOutlined />
                </Badge>
              </IconButton>
            </HoverablePaper.Actions>

            {showReplies && (
              <Box sx={{ display: "flex", flexDirection: "column" }}>
                <NoteReplies
                  noteId={note?._id}
                  replies={note?.replies}
                  openReplyBoxById={openReplyBoxById}
                  onResetReplyBoxId={() => setOpenReplyBoxById(null)}
                  compact={true}
                  isActive={isActive}
                  showReplies={showReplies}
                />
              </Box>
            )}
          </HoverablePaper>

          {index !== _sortedNoteList.length - 1 && (
            <Box sx={{ margin: 0, padding: 0 }}>
              <Divider />
            </Box>
          )}
        </React.Fragment>
      );
    })
  ) : (
    <EmptyResult height={150} />
  );
};

export default NoteList;